import { downloadFileViaAPI } from "@components/downloadSection";
import React, { useEffect, useState, useMemo } from "react";
import TableWithDynamicPagination from "@components/table/table";
import DownLoad from "@components/table/download";
// import WellBeEMPIService from "@services/empiService.service";
import { map, sortBy, filter, isEmpty, get, toString } from "lodash";
import axios from "axios";
import sessionService from "@services/session.service";
// import MatchingMergedRecords from "./matchingMergedRecords/matchingMergdRecords";
import { centricClientCheck, formatDisplayDate, getClientName, getDateWithLocalTimeZone, getFormateForClient, getSupplementalExportMeta } from "@utils/helpers";
import "./GenericTableReport.scss";
// import Download from "@assets/blueDownloadIcon.svg";
import ReportService from "@services/report.service";
import { Card, DatePicker, notification, Progress, Select, Spin, Typography } from "antd";

import CustomTooltip from "@pages/tool-tip";
import MillenniumLogo from "@assets/Millennium_Logo.png";
import moment from "moment";

import { FilterCountBtn } from "@components/filters/colFilters";
import { useGenericTableStore } from "@stores/useGenericTableStore";
import HealthemSpinner from "@components/healthemSpinner/healthemSpinner";
import { useNavigateToMemberdetails } from "@utils/customHooks";
import { dashBoardReportPageMapping, dateFormatConfig } from "@utils/constants";
import { GenericColumnConfig } from "./GenericColumnConfig";
import { ColConfigProvider, useColConfigContext } from "./useColConfig";
import { baseHeaderCardConfig, headerTitlesByReport } from "./useHeaderKPICardConfig";
import exportToExcel from "@utils/applyExcelStyle";
const centerAlignedFormatTypes = ["CENTER", "COLORED", "DATE", "DATETIME"];
const { Title, Text } = Typography;

const GetRender = ({ value, record, item, reportTitle }: any) => {
  const { goToMemberDetails } = useNavigateToMemberdetails();

  const [loader, setLoader] = useState(false);
  const formatTypes = useMemo(() => {
    if (item.format_type) {
      return item.format_type?.split("$|");
    }
    return [];
  }, [item.format_type]);

  const className = useMemo(() => {
    let renderClass = "col";
    if (formatTypes.some((type: string) => type.includes("LINK"))) {
      renderClass += record.has_patient_access ? " col-link" : " col-disabled-link";
    }

    if (centerAlignedFormatTypes.some((type) => formatTypes.includes(type))) {
      renderClass += " col-center";
    }

    if (formatTypes.includes("LEFT")) {
      renderClass += " col-left";
    }

    if (formatTypes.includes("COLORED")) {
      renderClass += ` col-color-${record.hasOwnProperty(item.dataIndex + "_flag") ? record[item.dataIndex + "_flag"]?.toLowerCase() : (toString(value) || "")?.toLowerCase()?.split(" ").join("")}`;
    }
    return renderClass;
  }, [formatTypes, item, record, value]);

  const getValue = useMemo(() => {
    if (formatTypes.includes("DATETIME")) {
      return moment(value).isValid() ? formatDisplayDate(toString(value), "reminderDateActualFormat", "defaultDateFormatWithTime", false) : "--";
    } else if (formatTypes.includes("DATEWITHSLASHFORYYYYMMDD") ) {
      return moment(value).isValid() ? `${formatDisplayDate(value, "createDateFormat","slashFormat")}` : "--";
    } else if (formatTypes.includes("DATEWITHSLASHFORMMDDYYYY") ) {
      return moment(value).isValid() ? `${formatDisplayDate(value, "createDateFormat","LastActionFormat")}` : "--";
    } else if (formatTypes.includes("DATE")) {
      return moment(value).isValid() ? `${formatDisplayDate(value, "createDateFormat")}` : "--";
    } else {
      return value;
    }
  }, [formatTypes, value]);

  const onClickAction = React.useCallback(() => {
    console.log("GetRender.onClickAction");
    if (formatTypes.some((type: string) => type.includes("LINK")) && record.has_patient_access) {
      const pageToNavigate = formatTypes.find((type: string) => type.includes("LINK")).match(/LINK-(.+)/)[1];
      if (pageToNavigate === "MEMBERPROFILE") {
        goToMemberDetails({ condition: record.has_patient_access, patientId: record.patient_id, fromPage: `Report / ${reportTitle}`, setLoader });
      }
    }
  }, [formatTypes, goToMemberDetails, record.has_patient_access, record.patient_id, reportTitle]);

  return (
    <Spin spinning={loader} indicator={<HealthemSpinner />}>
      <div className={`${className}`} onClick={onClickAction}>
        <CustomTooltip toolTipvalue={getValue} />
      </div>
    </Spin>
  );
};

const useTopFilters = (reportPageName = '') => {
  const [topFilters, settopFilters] = useGenericTableStore(state => [state.topFilters, state.settopFilters])
  const [tableParams, setTableParams] = useGenericTableStore(state => [state.tableParams, state.setTableParams])
  const [downloadLoader, setDownloadLoader] = useState<boolean>(false);
  const currentYear = moment().year();
  const [selectedYear, setSelectedYear] = useState<number>(currentYear);
  let TopFiltersComponent = () => <></>
  let TopFiltersExtraComponent = () => <></>;
  let topFiltersTableDeps: any[] = []
  let topFiltersPayload = {}
  const years = [
    { id: 1, value: currentYear },
    { id: 2, value: currentYear - 1 },
  ];

  const disabledDate = (current: any) => {
    const startOfMonth = moment().startOf('month');
    const twentyFourMonthsAgo = moment().subtract(23, 'months').startOf('month');
    return current && (current < twentyFourMonthsAgo || current > startOfMonth.endOf('month'));
  };

  const commonProps = {
    separator: <span className="range-picker-separator">-</span>,
    size: 'large',
    allowClear: true,
    className: 'column_filter__date_input_selector',
    dropdownClassName: 'column_filter__date_popup',
  };

  function exportSupplementalSourceData() {
    setDownloadLoader(true);
    ReportService.exportSourceData(reportPageName).subscribe({
      next: (v) => {
        setDownloadLoader(false);
        const data = v.data.data.response || [];
        const dataLoadDate = v.data.data.dataLoadDate || null;
        const { filename, sheetName } = getSupplementalExportMeta(reportPageName, dataLoadDate);

        if (isEmpty(data)) {
          notification.warning({
            message: "",
            description: 'No data available to export',
          });
          return;
        }
        
        const columns = Object.keys(data[0]).map((key) => ({
          tableHeaderName: key,
          dataIndex: key,
        }));

        exportToExcel({
          filename,
          sheets: [
            {
              sheetName: sheetName,
              columns: columns.map((col) => ({
                header: col.tableHeaderName,
                key: col.dataIndex,
              })),
              data: data,
              styles: { headerBold: true },
            },
          ],
        });
      },
      error: (e) => {
        setDownloadLoader(false);
        console.error("Error fetching data:", e);
      },
    });
  }

  const supplementalExportConfig = {
    isDateDisabled: true,
    renderExtra: () => (
      <DownLoad
        title="Export Source Data"
        onClick={exportSupplementalSourceData}
        className="generic-report__download"
        loader={downloadLoader}
      />
    )
  };

  const monthRangeConfig = {
    isDateDisabled: false,
    picker: 'month',
    format: 'YYYY-MM',
    disabledDate,
    value: [
      topFilters.startDate ? moment(topFilters.startDate, 'YYYY-MM') : null,
      topFilters.endDate ? moment(topFilters.endDate, 'YYYY-MM') : null,
    ],
    onChange: (range: any) => {
      if (!range) {
        settopFilters({});
        return;
      }

      settopFilters({
        startDate: range?.[0]?.format('YYYY-MM'),
        endDate: range?.[1]?.format('YYYY-MM'),
      });

      setTableParams({
        ...tableParams,
        pagination: {
          ...tableParams?.pagination,
          current: 1,
        },
      });
    },
  };

  const YearSelectComponent = () => (
    <Select
      size="large"
      style={{ width: 130 }}
      value={selectedYear}
      onChange={(year) => {
        setSelectedYear(year);
        settopFilters({ year });
        setTableParams({
          ...tableParams,
          pagination: {
            ...tableParams?.pagination,
            current: 1,
          },
        });
      }}
    >
      {years.map((year) => (
        <Select.Option key={year.id} value={year.value}>
          PY {year.value}
        </Select.Option>
      ))}
    </Select>
  );

  const reportConfigs: Record<string, any> = {
    'CASEMGR-DASHBOARD': {
      isDateDisabled: true,
      picker: 'date',
      format: dateFormatConfig.get(getClientName())['defaultDateFormat'],
      value: topFilters.startDate && topFilters.endDate
        ? [
            moment.utc(moment(topFilters.startDate).format('MM/DD/YYYY')),
            moment.utc(moment(topFilters.endDate).format('MM/DD/YYYY')),
          ]
        : undefined,
      ranges: {
        'More Filters:': [null, null],
        'Last 1 Day': [moment.utc().subtract(1, 'days'), moment.utc().subtract(1, 'days')],
        'Last 7 Days': [moment.utc().subtract(7, 'days'), moment.utc()],
        'Current Month to Date': [
          moment.utc(moment().startOf('month').format(getFormateForClient())),
          moment(),
        ],
      },
      onChange: (range: any) => {
        settopFilters({
          startDate: range?.[0]?.startOf('date').format('YYYY-MM-DD HH:mm:ss'),
          endDate: range?.[1]?.endOf('date').format('YYYY-MM-DD HH:mm:ss'),
        });
      },
    },
    'HCC-GAP-REPORT': {
      ...monthRangeConfig
    },
    'HCC-PERIODICAL-GAP-REPORT':{
      isDateDisabled: false,
      renderTopFilter: () => <YearSelectComponent />,
    },
    'AETNA-MEDICAL-SUPPLEMENTAL-DASHBOARD': {
       ...supplementalExportConfig
    },
    'AETNA-LAB-SUPPLEMENTAL-DASHBOARD': {
       ...supplementalExportConfig
    },
  };

  const config = reportConfigs[reportPageName];

  if (config && !(config.isDateDisabled)) {
    if (!config.renderTopFilter) {
      topFiltersTableDeps = [topFilters.startDate, topFilters.endDate];
      topFiltersPayload = { ...topFilters };

      TopFiltersComponent = () => (
        <DatePicker.RangePicker
          {...commonProps}
          {...config}
          style={{ width: '240px' }}
        />
      );
    } else {
      topFiltersTableDeps = [topFilters.year];
      topFiltersPayload = { year: topFilters.year };
      TopFiltersComponent = config.renderTopFilter;
    }
  }

  if (config?.renderExtra) {
    TopFiltersExtraComponent = config.renderExtra;
  }

  return {
    topFilters,
    settopFilters,
    topFiltersTableDeps,
    topFiltersPayload,
    TopFiltersComponent,
    TopFiltersExtraComponent
  }
}

const GenericCard = ({ titles, total, recaptured, percent, loading, footerTitle }: any) => {
  return (
    <Spin spinning={loading} indicator={<HealthemSpinner />}>
    <Card className="generic-report__hcc-gap-header__card">
      <div className="generic-report__hcc-gap-header__card__content">
        <div className="generic-report__hcc-gap-header__card__text">
          {titles.map((title: string, index: number) => (
            <div key={index}>
              <Text type="secondary" className="generic-report__hcc-gap-header__card__text__title">
                {title}
              </Text>
              <Title level={4} className="generic-report__hcc-gap-header__card__text__value">
                {index === 0 ? total.toLocaleString() : recaptured.toLocaleString()}
              </Title>
            </div>
          ))}
        </div>
        <div className="generic-report__hcc-gap-header__card__progress-bar">
          <Progress
            type="dashboard"
            percent={percent}
            strokeColor="#1CA351"
            gapDegree={150}
            width={90}
            strokeWidth={15}
            strokeLinecap="square"
            format={(percent) => <span className="generic-report__hcc-gap-header__card__progress-bar__title">{percent}%</span>}
          />
          <Text strong className="generic-report__hcc-gap-header__card__progress-bar__footer-note">
            {footerTitle}
          </Text>
        </div>
      </div>
    </Card>
    </Spin>
  );
};

interface CardCountsData {
  diagnosisTotal: number;
  diagnosisRecaptured: number;
  hccTotal: number;
  hccRecaptured: number;
  diagnosisRecapturedPercentage: number,
  hccRecapturedPercentage: number
  totalHCCPatient: number;
  patientWithNoHCC: number;
  patientWithNoHCCPercentage: number;
  totalDiagnosisPatient: number;
  patientWithNoDiagnosis: number;
  patientWithNoDiagnosisPercentage: number;
  totalPatientWithNoEncounter: number;
  patientsWithNoEncounter: number;
  patientsWithNoEncounterPercentage: number,
  hccNewlyCaptured: number,
  hccNewlyCapturedPercentage: number,
  diagnosisNewlyCaptured: number,
  diagnosisNewlyCapturedPercentage: number
}

const GenericTableReport = ({ selectedReport }: any) => {
  const [columnsNeedToShowInTable, setColumnsNeedToShowInTable] = useState<any>([]);
  const [columnLoading, setColumnLoading] = useState(false);
  const [downloadLoader, setDownloadLoader] = useState(false);
  const [scoreCardValue, setScoreCardValue] = useState<CardCountsData | null>(null);
  const [scoreCardLoading, setScoreCardLoading] = useState(false);
  const filteredInfo = useGenericTableStore((state) => state.filteredInfo);
  const setFilteredInfo = useGenericTableStore((state) => state.setFilteredInfo);
  const showFilters = useGenericTableStore((state) => state.showFilters);
  const setShowFilters = useGenericTableStore((state) => state.setShowFilters);
  const isCentric = centricClientCheck()
  const currentYear = new Date().getFullYear();  

  const {reportKey , reportTitle , reportLastUpdatedDate , reportPageName} = useMemo(() => {
    const reportKey = get(selectedReport, "value", '');
    const reportTitle = get(selectedReport, "title", '');
    const reportLastUpdatedDate = get(selectedReport, "lastUpdatedDate", '');
    const reportPageName = get(dashBoardReportPageMapping, get(selectedReport, "value", null), "");

    return {reportKey , reportTitle , reportLastUpdatedDate , reportPageName};
  } , [selectedReport]) 

  const {
    topFiltersTableDeps,
    topFiltersPayload,
    TopFiltersComponent,
    TopFiltersExtraComponent
  } = useTopFilters(reportPageName)

  const handleFilteredInfo = (val : any) => {
    setFilteredInfo({[reportKey] : val})
  }

  const { toggleDrawer, tableConfigCallback, tableConfigData , setTableConfigData } = useColConfigContext();
  const isHccReport = reportPageName === "HCC-GAP-REPORT" || reportPageName === "HCC-PERIODICAL-GAP-REPORT";

  const fetchData = async (payload: any) => {
    console.log("GenericTableReport.fetchData");
    const _data = await axios
      .post(`${sessionService.getClient()?.appServiceUrl}/report/getReportTableData`, { ...payload, reportName: reportPageName, topFilters: topFiltersPayload })
      .then((v) => {
        return v?.data?.data;
      });

    return {
      totalCount: _data?.count,
      data: _data?.records,
    };
  };

  const isEmptyFilters = (obj: any) =>
    !obj ||
    Object.values(obj).every(
      (v) => v === undefined || v === null || v === ''
    );

  function fetchScoreCardData(datePayload: any) {
    let payload = { ...datePayload };

    if (isEmptyFilters(datePayload)) {
      if (reportPageName === "HCC-GAP-REPORT") {
        const now = moment().startOf('month');
        payload = {
          reportPageName,
          startDate: now.clone().subtract(23, 'months').format('YYYY-MM'),
          endDate: now.format('YYYY-MM'),
        };
      }
      else if (reportPageName === "HCC-PERIODICAL-GAP-REPORT") {
        payload = {
          reportPageName,
          year: moment().year()
        };
      }
    }
    else {
      payload = {
        reportPageName,
        ...datePayload,
      };
    }

    setScoreCardLoading(true);
    ReportService.getHCCScoreCardData(payload).subscribe({
      next: (v) => {
        const data = v.data.data;
        setScoreCardValue(data);
        setScoreCardLoading(false);
      },
      error: (e) => {
        setScoreCardLoading(false);
        console.error("Error fetching data:", e);
      },
    });
  }

  useEffect(() => {
    if (isHccReport) {
      fetchScoreCardData(topFiltersPayload);
    }
  }, [JSON.stringify(topFiltersPayload), reportPageName]);

  const getColumns = React.useCallback(() => {
    setColumnLoading(true);
    ReportService.getColumnsList(reportPageName).subscribe({
      next: (v) => {
        let _columnsNeedToShowInTable = filter(v.data.data?.columns, (item) => {
          return item.isDisplay === "Y";
        });
        setColumnsNeedToShowInTable(_columnsNeedToShowInTable);
        setColumnLoading(false);
        let _columns = map(
          _columnsNeedToShowInTable.filter((col: any) => col.isDisplay === "Y"),
          (item) => {
            const columnWidth = item.columnWidth && item.columnWidth !== "null" ? Number(item.columnWidth) : 200;
            
            return {
              ...item,
              label: item.displayName,
              dataIndex: item.dataIndex,
              key: item.key,
              sequence: item.order,
              width: columnWidth,
              ...((item.format_type || "").includes("FIXED") && { fixed: true }),
              render: (value: any, record: any) => {
                return <GetRender value={value} record={record} item={item} reportTitle={reportTitle} />;
              },
              isDraggable: (item.format_type || "").includes("FIXED") ? false : item.isDraggable,
              isSelected : ((item.format_type || "").includes("FIXED") ? true : item.isSelected)
            };
          }
        );
        _columns = sortBy(_columns, [
          // Sort by isDraggable in ascending order (false first, true later)
          "isDraggable",
          // Then sort by order to maintain the original order within each group
          "order",
        ]);
        tableConfigCallback(_columns);
        setTableConfigData(_columns);
      },
      error: (e) => {
        console.log(e);
        setColumnLoading(false);
      },
    });
  }, [reportPageName, reportTitle, setTableConfigData, tableConfigCallback]);

  useEffect(() => {
    getColumns();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedReport]);

  function handleDownload({ filters = {}, sortByCol, sortType }: any) {
    console.log("GenericTableReport.handleDownload");
    setDownloadLoader(true);

    ReportService.downloadReport({
      reportName: reportPageName,
      filters,
      sortByCol,
      sortType,
      columns: columnsNeedToShowInTable,
      topFilters: topFiltersPayload,
    }).subscribe({
      next: async (v: any) => {
        if (v?.data?.status === "OK" && v?.data?.data?.fileURL) {
          const fileURL = v.data.data.fileURL;

          // 1. Extract the exact filename from the response URL
          const cleanUrl = decodeURIComponent(fileURL.split("?")[0]);
          const fileName = cleanUrl.substring(cleanUrl.lastIndexOf("/") + 1) || `${reportPageName}.csv`;

          // 2. Download the file via the secure proxy helper
          await downloadFileViaAPI(fileURL, fileName);
        }
        setDownloadLoader(false);
      },
      error: (e: any) => {
        console.error("Error downloading report:", e);
        setDownloadLoader(false);
      },
    });
  }

  const headerCardData = isHccReport 
    ? baseHeaderCardConfig.map((item, index) => {
      const total = scoreCardValue?.[item.totalKey as keyof CardCountsData] ?? 0;
      const recaptured = scoreCardValue?.[item.recapturedKey as keyof CardCountsData] ?? 0;
      const percent = Math.round(scoreCardValue?.[item.percentKey as keyof CardCountsData] ?? 0);
      const rawTitles = headerTitlesByReport[reportPageName][index];

      const titles =
        reportPageName === "HCC-GAP-REPORT"
          ? rawTitles.map((title: any) =>
            title.replace("{year}", currentYear.toString())
          )
          : rawTitles;

      return {
        titles,
        total,
        recaptured,
        percent,
        footerTitle: item.footerTitle,
      };
    })
    : [];

  return (
    <>
      <div className="generic-report">
        <div className="generic-report__header">
          {!isCentric && <img src={MillenniumLogo} alt={"download"} />}
          <span className="generic-report__header_title">{reportTitle}</span>
          <FilterCountBtn filteredInfo={filteredInfo[reportKey]} className={"generic-report__header__filter_btn"} showFilters={showFilters} setShowFilters={setShowFilters} />
        </div>
        {columnsNeedToShowInTable.length > 0 ? <i style={{ marginRight: 8 }} className="btn-icon icon-settings clr-n125" onClick={() => toggleDrawer()} /> : <></>}
        <div className="top-filters mr-05">
          <TopFiltersComponent />
          <TopFiltersExtraComponent />
        </div>
        <DownLoad onClick={(data: any) => handleDownload(data)} className="generic-report__download" loader={downloadLoader} filteredInfo={filteredInfo[reportKey]}/>
      </div>
      {isHccReport && (
        <div className="generic-report__hcc-gap-header custom-scroll-bar mb-1">
          {headerCardData.map((card: any, index: any) => (
            <GenericCard
              key={index}
              titles={card.titles}
              total={card.total}
              recaptured={card.recaptured}
              percent={card.percent}
              loading={scoreCardLoading}
              footerTitle={card.footerTitle}
            />
          ))}
        </div>
      )}
      <TableWithDynamicPagination
        condition={!isEmpty(reportPageName)}
        dependencyProps={[reportPageName, ...topFiltersTableDeps]}
        className="ui-expandable-table"
        columns={tableConfigData.filter((item: any) => {
          return item.isSelected;
        })}
        handleFetchData={fetchData}
        perPageCount={10}
        columnOriginalList={columnsNeedToShowInTable}
        loading={columnLoading}
        message={`Report last updated on ${getDateWithLocalTimeZone(reportLastUpdatedDate)}`}
        filteredInfo={filteredInfo[reportKey]}
        setFilteredInfo={handleFilteredInfo}
        scrollProp = {{ y: window.innerHeight - 429 }}
        reportName={reportPageName}
      />
      <GenericColumnConfig
        filteredInfo={filteredInfo[reportKey]}
        columnListData={columnsNeedToShowInTable}
        getColumns={getColumns}
        reportName={reportPageName}
      />
    </>
  );
};

const Wrapper: React.FC<any> = function (props) {
  return (
    <ColConfigProvider>
      <GenericTableReport {...props} />
    </ColConfigProvider>
  );
};

export default Wrapper;
